"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastScreenName = exports.loadScreenAction = void 0;
const constants_1 = require("../../../constants");
const loggingTypes_1 = require("../types/loggingTypes");
const customDimensionsClass_1 = require("./customDimensionsClass");
const sendLoggingEvent_1 = require("./sendLoggingEvent");
const helpers_1 = require("../../../helpers");
function loadScreenAction({ currentScreen, memberId, }) {
    (0, sendLoggingEvent_1.sendLoggingEvent)({
        actionNameLvl1: loggingTypes_1.EnumActionNameLevel1.SCREEN,
        actionNameLvl2: loggingTypes_1.EnumActionNameLevel2.LOAD,
        actionNameLvl3: loggingTypes_1.EnumActionNameLevel3.SUCCESS,
        currentScreenName: currentScreen,
        memberId: memberId,
        ux_type: loggingTypes_1.EnumUxTypes.SCREEN,
        sessionFunnel: false,
    }).then(() => {
        let prev = customDimensionsClass_1.CustomDimensionsClass.cookies[constants_1.CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME]
            ? customDimensionsClass_1.CustomDimensionsClass.cookies[constants_1.CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME].split(",")
            : [loggingTypes_1.EnumLoggingScreenNames.NA];
        // previous
        if (prev[prev.length - 1] !== currentScreen) {
            prev = [prev[prev.length - 1], currentScreen];
            (0, helpers_1.setCookie)(constants_1.CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME, prev.join(","));
        }
    });
}
exports.loadScreenAction = loadScreenAction;
const getLastScreenName = (currentScreenName = null) => {
    const prev = customDimensionsClass_1.CustomDimensionsClass.cookies[constants_1.CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME]
        ? customDimensionsClass_1.CustomDimensionsClass.cookies[constants_1.CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME].split(",")
        : [loggingTypes_1.EnumLoggingScreenNames.NA];
    if (!currentScreenName) {
        return prev[prev.length - 1];
    }
    let prev_screen_name = loggingTypes_1.EnumLoggingScreenNames.NA;
    if (prev[prev.length - 1] != currentScreenName) {
        prev_screen_name = prev[prev.length - 1];
    }
    else if (prev[prev.length - 2]) {
        prev_screen_name = prev[prev.length - 2];
    }
    return prev_screen_name;
};
exports.getLastScreenName = getLastScreenName;
